"use client"

import { emptyTokenAndSelectionMetadata } from "@/actions/cookies/centraDefaultSessionFromCookies"
import { getCentraSessionFromCookiesClient } from "@/actions/cookies/getCentraSessionFromCookiesClient"
import depictClientOnlyClient from "@/lib/depict-client/depict-client-only-client-init"
import { formatPricesInTransformedData } from "@/lib/depict-client/helpers/formatPricesInTransformedData"
import { transformDepictProductData } from "@/lib/depict-client/helpers/transformDepictProductData"
import { RecommendRequestV3 } from "@/lib/depict-client/types/api/RecommendRequestV3"
import logger from "@/lib/logger/logger-init"
import { RequiredTokenAndSelectionMetadata } from "@/types/cookie-types"
import { match } from "ts-pattern"

//@todo: when going over to SSR rendered recommendedProducts from depict we need a ssr only version of this function

export const getDepictRecommendedProductsClient = async (req: RecommendRequestV3) => {
    let centraSession: RequiredTokenAndSelectionMetadata | null = null
    try {
        centraSession = await getCentraSessionFromCookiesClient()
    } catch (error) {
        logger.error(
            "Error fetching centra session in getDepictRecommendedProductsClient",
            error
        )
        return emptyTokenAndSelectionMetadata
    }
    const currentPricelist = centraSession?.metadata.currencyFormat

    const response = await depictClientOnlyClient.recommendations.getProducts({
        merchant: req.merchant,
        market: req.market,
        locale: req.locale,
        type: req.type,
        product_ids: req.product_ids,
        limit: req.limit,
        session_id: req.session_id
    })
    return match(response)
        .with({ success: true }, async data => {
            const transformedData = transformDepictProductData(data)
            if (
                Array.isArray(transformedData.displays) &&
                transformedData.displays.length === 0
            ) {
                return transformedData // Return unchanged if "displays" is missing
            }
            const transformedDataWithFormattedPrices = formatPricesInTransformedData(
                transformedData,
                currentPricelist
            )
            return transformedDataWithFormattedPrices
        })
        .with({ success: false }, ({ error }) => {
            logger.error("Error fetching products from Depict", error)

            return null
        })
        .exhaustive()
}
